/*
Author       : Dreamstechnologies
Template Name: Trucking App - Bootstrap Admin Template
*/
import feather from 'feather-icons'
;(function ($) {
  'use strict'

  // Variables declarations
  var $wrapper = $('.main-wrapper')
  var $slimScrolls = $('.slimscroll')
  var $pageWrapper = $('.page-wrapper')
  feather.replace()

  // Page Content Height Resize

  $(window).resize(function () {
    if ($('.page-wrapper').length > 0) {
      var height = $(window).height()
      $('.page-wrapper').css('min-height', height)
    }
  })

  // Header Scroll

  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $('.header').addClass('active')
    } else {
      $('.header').removeClass('active')
    }
  })

  // Mobile menu sidebar overlay

  $('body').append('<div class="sidebar-overlay"></div>')

  $(document).on('click', '#mobile_btn', function () {
    $('.main-wrapper').toggleClass('slide-nav')
    $('.sidebar-overlay').toggleClass('opened')
    $('html').addClass('menu-opened')
    $('#task_window').removeClass('opened')
    return false
  })

  $('.sidebar-overlay').on('click', function () {
    $('html').removeClass('menu-opened')
    $(this).removeClass('opened')
    $('.main-wrapper').removeClass('slide-nav')
    $('.sidebar-overlay').removeClass('opened')
    $('#task_window').removeClass('opened')
  })

  // Logo Hide Btn

  $(document).on('click', '.hideset', function () {
    $(this).parent().parent().parent().hide()
  })

  $(document).on('click', '.delete-set', function () {
    $(this).parent().parent().hide()
  })

  // Stick Sidebar

  if ($(window).width() > 767) {
    if ($('.theiaStickySidebar').length > 0) {
      $('.theiaStickySidebar').theiaStickySidebar({
        // Settings
        additionalMarginTop: 30,
      })
    }
  }

  // Sidebar Slimscroll

  if ($slimScrolls.length > 0) {
    $slimScrolls.slimScroll({
      height: 'auto',
      width: '100%',
      position: 'right',
      size: '7px',
      color: '#ccc',
      wheelStep: 10,
      touchScrollStep: 100,
    })
    var wHeight = $(window).height() - 60
    $slimScrolls.height(wHeight)
    $('.sidebar .slimScrollDiv').height(wHeight)
    $(window).resize(function () {
      var rHeight = $(window).height() - 60
      $slimScrolls.height(rHeight)
      $('.sidebar .slimScrollDiv').height(rHeight)
    })
  }

  // Sidebar

  var Sidemenu = function () {
    this.$menuItem = $('.sidebar-menu a')
  }

  function init() {
    var $this = Sidemenu
    $('.sidebar-menu a').on('click', function (e) {
      if ($(this).parent().hasClass('submenu')) {
        e.preventDefault()
      }
      if (!$(this).hasClass('subdrop')) {
        $('ul', $(this).parents('ul:first')).slideUp(250)
        $('a', $(this).parents('ul:first')).removeClass('subdrop')
        $(this).next('ul').slideDown(350)
        $(this).addClass('subdrop')
      } else if ($(this).hasClass('subdrop')) {
        $(this).removeClass('subdrop')
        $(this).next('ul').slideUp(350)
      }
    })
    $('.sidebar-menu ul li.submenu a.active')
      .parents('li:last')
      .children('a:first')
      .addClass('active')
      .trigger('click')
  }

  // Sidebar Initiate

  init()
  $(document).on('mouseover', function (e) {
    e.stopPropagation()
    if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
      var targ = $(e.target).closest('.sidebar, .header-left').length
      if (targ) {
        $('body').addClass('expand-menu')
        $('.subdrop + ul').slideDown()
      } else {
        $('body').removeClass('expand-menu')
        $('.subdrop + ul').slideUp()
      }
      return false
    }
  })

  $(document).on('click', '#toggle_btn', function () {
    if ($('body').hasClass('mini-sidebar')) {
      $('body').removeClass('mini-sidebar')
      $(this).addClass('active')
      $('.subdrop + ul')
      localStorage.setItem('screenModeNightTokenState', 'night')
      setTimeout(function () {
        $('body').removeClass('mini-sidebar')
        $('.header-left').addClass('active')
      }, 100)
    } else {
      $('body').addClass('mini-sidebar')
      $(this).removeClass('active')
      $('.subdrop + ul')
      localStorage.removeItem('screenModeNightTokenState', 'night')
      setTimeout(function () {
        $('body').addClass('mini-sidebar')
        $('.header-left').removeClass('active')
      }, 100)
    }
    return false
  })

  // Datatable

  if ($('.datatable').length > 0) {
    $('.datatable').DataTable({
      retrieve: true,
      lengthMenu: [
        [5, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      language: {
        search: ' ',
        info: 'Showing _START_ - _END_ of _TOTAL_ entries',
        lengthMenu: 'Show Per Page _MENU_',
        paginate: {
          next: '<i class="feather-chevron-right"></i>',
          previous: '<i class="feather-chevron-left"></i>',
        },
      },
      initComplete: (settings, json) => {
        $('.dataTables_info').appendTo('#tableinfo')
        $('.dataTables_paginate').appendTo('#tablepage')
        $('.dataTables_length').appendTo('#tablelength')
        $('.dataTables_filter').appendTo('#tablefilter')
      },
    })
  }

  // Select All

  var selectAllItems = '#select-all'
  var checkboxItem = ':checkbox'
  $(selectAllItems).click(function () {
    if (this.checked) {
      $(checkboxItem).each(function () {
        this.checked = true
      })
    } else {
      $(checkboxItem).each(function () {
        this.checked = false
      })
    }
  })

  // Datetimepicker

  if ($('.datetimepicker').length > 0) {
    $('.datetimepicker').datetimepicker({
      format: 'DD-MM-YYYY',
      icons: {
        up: 'fas fa-angle-up',
        down: 'fas fa-angle-down',
        next: 'fas fa-angle-right',
        previous: 'fas fa-angle-left',
      },
    })
  }

  // Toggle Password

  if ($('.toggle-password').length > 0) {
    $(document).on('click', '.toggle-password', function () {
      $(this).toggleClass('fa-eye fa-eye-slash')
      var input = $('.pass-input')
      if (input.attr('type') == 'password') {
        input.attr('type', 'text')
      } else {
        input.attr('type', 'password')
      }
    })
  }

  // Select 2
  $(document).ready(function () {
    if ($('.select').length > 0) {
      $('.select').select2({
        minimumResultsForSearch: -1,
        width: '100%',
      })
    }
  })
  // Tooltip

  if ($('[data-bs-toggle="tooltip"]').length > 0) {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    )
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }

  // Sidebar Scroll
  $(document).ready(function () {
    $('.sidebar').hover(function () {
      $(this).toggleClass('sideWrapperOpen')
    })
  })
})(jQuery)
